import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import { media } from '@/utils/mixin';

export const FiltersWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  &:not(:first-child) {
    margin-top: 20px;
  }

  ${media.tablet(css`
    grid-template-columns: repeat(1, 1fr);
    gap: 0;
    box-shadow: ${(props) => props.theme.blackShadow200};
  `)}
`;

export const StockShowMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;

  ${media.tablet(
    css`
      justify-content: flex-start;
      margin-left: 10px;
    `
  )}
`;

export const MoreParams = styled.div<{ isVisible?: boolean }>`
  display: none;

  ${({ isVisible }) =>
    isVisible &&
    css`
      display: block;
      margin-top: 30px;

      ${media.tablet(css`
        margin-top: 20px;
      `)}
    `}
`;

export const SpecialFilterList = styled.div`
  display: flex;
  margin-top: 30px;
  height: 20px;

  ${media.tablet(css`
    flex-direction: column;
    margin: 20px -10px 0;
    height: auto;
  `)}
`;

export const SpecialFilterItem = styled.div`
  &:not(:first-child) {
    margin-left: 60px;
  }
`;

export const SelectedFiltersWrapper = styled.div`
  margin-top: 40px;

  ${media.tablet(css`
    margin-top: 30px;
  `)}
`;

export const CarsListHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 42px;

  ${media.tablet(css`
    margin-top: 30px;
  `)}
`;

export const CarsListHeaderLeft = styled.div``;

export const CarsListHeaderRight = styled.div`
  display: flex;
  align-items: center;
`;

export const CarsFilterResultText = styled.p`
  font-size: 18px;
  line-height: 21px;
  color: ${(props) => props.theme.black200};

  ${media.tablet(css`
    font-size: 16px;
    line-height: 19px;
  `)}
`;

export const CarsFilterResultCount = styled.span`
  font-weight: 700;
`;

export const CarsViewToggleWrapper = styled.div`
  margin-left: 32px;

  @media (max-width: 1899px) {
    display: none;
  }
`;

export const CarsListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 24px -6px 0;

  ${media.tablet(css`
    margin: 14px -6px 0;
  `)}
`;

export const CarsListItem = styled.div<{ view: 'portrait' | 'landscape' }>`
  padding: 6px;

  ${({ view }) =>
    view === 'portrait'
      ? css`
          flex: 0 0 25%;
          max-width: 25%;

          ${media.tablet(css`
            flex: 0 0 33.33%;
            max-width: 33.33%;
          `)}

          ${media.tabletSmall(css`
            flex: 0 0 50%;
            max-width: 50%;
          `)}

          ${media.mobile(css`
            flex: 0 0 100%;
            max-width: 100%;
          `)}
        `
      : css`
          flex: 0 0 100%;
          max-width: 100%;
        `}
`;

export const BannerWrapper = styled.div<{
  isHorizontal?: boolean;
  isVertical?: boolean;
  isVerticalTwo?: boolean;
  isVerticalThree?: boolean;
}>`
  padding: 6px;

  ${({ isHorizontal }) =>
    isHorizontal &&
    css`
      flex: 0 0 100%;
      max-width: 100%;
    `}

  ${({ isVertical }) =>
    isVertical &&
    css`
      flex: 0 0 25%;
      max-width: 25%;
    `}

  ${({ isVerticalTwo }) =>
    isVerticalTwo &&
    css`
      flex: 0 0 50%;
      max-width: 50%;
    `}

  ${({ isVerticalThree }) =>
    isVerticalThree &&
    css`
      flex: 0 0 75%;
      max-width: 75%;
    `}

  ${media.tablet(css`
    flex: 0 0 33.33%;
    max-width: 33.33%;
  `)}

  ${media.tabletSmall(css`
    flex: 0 0 50%;
    max-width: 50%;
  `)}

  ${media.mobile(css`
    flex: 0 0 100%;
    max-width: 100%;
  `)}
`;

export const PaginationWrapper = styled.div`
  padding: 15px;
  margin-top: 14px;

  ${media.mobile(
    css`
      z-index: 499;
      position: sticky;
      bottom: 0;
      padding: 15px 0 20px;
      margin: 10px -20px -25px;
      background: ${(props) => props.theme.white_1};
      box-shadow: ${(props) => props.theme.whiteShadow};
    `
  )}
`;

export const PageTitle = styled.h1`
  font-weight: 700;
  font-size: 25px;
  line-height: 29px;
  margin: 0 0 25px;
  color: ${(props) => props.theme.black200};

  ${media.tablet(css`
    font-size: 23px;
    line-height: 27px;
    margin: 0 0 15px;
  `)}
`;

export const MobileFiltersWrapper = styled.div`
  margin-top: 20px;
`;

export const MobileFilterWrapper = styled.div`
  padding: 18px 15px;
  border-bottom: 1px solid ${(props) => props.theme.gray};
`;

export const FilterButtonWrapper = styled.div`
  position: sticky;
  bottom: -15px;
  padding: 30px 10px;
  margin: 10px -10px -15px;
  background: ${(props) => props.theme.white_1};
  box-shadow: ${(props) => props.theme.whiteShadow};
`;

export const FilterButton = styled.button`
  display: flex;
  justify-content: center;
  padding: 11px 0;
  width: 100%;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  border-radius: 20px;
  text-transform: uppercase;
  background: ${colors.main};
  color: ${colors.white};
  transition: 0.3s;

  &:hover {
    background: ${colors.main100};
  }
`;

export const MobileFilterItemWrapper = styled.div`
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid ${(props) => props.theme.gray};
`;

export const CompareButtonWrapper = styled.div`
  z-index: 200;
  display: flex;
  justify-content: center;
  position: sticky;
  margin-top: 20px;
  bottom: 40px;

  ${media.mobile(css`
    display: block;
    bottom: 80px;
  `)}
`;

export const NotFoundCarsWrapper = styled.div`
  margin: 20px auto 0;
`;
